var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailfooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0092 20C2.3604 20 1.81911 19.78 1.38533 19.34C0.951546 18.9 0.734185 18.3505 0.733246 17.6914V2.30857C0.733246 1.65048 0.950607 1.10143 1.38533 0.661428C1.82005 0.221428 2.36087 0.000952381 3.00779 0H23.8097C24.4575 0 24.9984 0.220476 25.4321 0.661428C25.8659 1.10238 26.0833 1.65143 26.0842 2.30857V17.6929C26.0842 18.35 25.8669 18.899 25.4321 19.34C24.9974 19.781 24.4566 20.0009 23.8097 20H3.0092ZM13.4087 10.1657L24.6758 2.69286L24.242 1.42857L13.4087 8.57143L2.57542 1.42857L2.14163 2.69286L13.4087 10.1657Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailfooter);
export default __webpack_public_path__ + "static/media/emailfooter.3d85e342baedf2b4ee56dce2ac8e0c89.svg";
export { ForwardRef as ReactComponent };